import { render, staticRenderFns } from "./NewChat.vue?vue&type=template&id=40d0a044&scoped=true&"
import script from "./new-chat.js?vue&type=script&lang=js&"
export * from "./new-chat.js?vue&type=script&lang=js&"
import style0 from "./new-chat.scss?vue&type=style&index=0&id=40d0a044&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40d0a044",
  null
  
)

export default component.exports